import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../app/axios';
import { API_BASE_URL } from '../../app/utils';

const endpoint = `${API_BASE_URL}/user-store/v1/users/me/favourites`;
export const syncFavourites = createAsyncThunk('favourites/sync', async (request, { rejectWithValue }) => {
  const { owner, operation = 'load', ...body } = request;
  try {
    let response;
    if (operation === 'pin') response = await axios.post(endpoint, body);
    else if (operation === 'remove') response = await axios.delete(`${endpoint}/${encodeURIComponent(body.id)}`);
    else if (operation === 'order') response = await axios.put(`${endpoint}/order`, body);
    else response = await axios.get(endpoint);
    return response.data;
  } catch (error) {
    return rejectWithValue({ status: error.response?.status, message: error.response?.data?.message || 'Unable to update favourites. Please try again.' });
  }
}, {
  condition: ({ owner }, { getState }) => {
    const state = getState().favourites;
    return state.owner !== owner || state.status !== 'loading';
  },
});

const initialState = { owner: null, items: [], status: 'idle', error: null, requestId: null };
const slice = createSlice({
  name: 'favourites',
  initialState,
  reducers: { resetFavourites: () => initialState },
  extraReducers: (builder) => builder
    .addCase(syncFavourites.pending, (state, action) => {
      if (state.owner !== action.meta.arg.owner) state.items = [];
      state.owner = action.meta.arg.owner;
      state.status = 'loading';
      state.error = null;
      state.requestId = action.meta.requestId;
    })
    .addCase(syncFavourites.fulfilled, (state, action) => {
      if (state.requestId !== action.meta.requestId) return;
      state.items = action.payload;
      state.status = 'succeeded';
    })
    .addCase(syncFavourites.rejected, (state, action) => {
      if (state.requestId !== action.meta.requestId) return;
      state.status = 'failed';
      state.error = action.payload?.message || 'Unable to load favourites.';
    }),
});
export const { resetFavourites } = slice.actions;
export default slice.reducer;
